<script lang="ts">
    
    import { onDestroy } from 'svelte';
    import { fly } from 'svelte/transition';
    import type { GameType, RealTimeEvent } from '../../global';
    import type { Board } from "../../Model/Board";
    import type { Game } from '../../Model/Game';
    import type { Player } from "../../Model/Player";
    import { boardsFactory, boardsService } from "../../Services";
    import type { EventsChannel } from '../../Services/EventsChannel';
    import AspectRatio from '../Shared/AspectRatio.svelte';
    import Picture from "../Shared/Picture.svelte";
    import Watch from "../Watch.svelte";

    export let player: Player;
    export let game: Game;

    const boardCellsByGameType: Record<GameType, number> = {
      'Bingo90'             : 15,
      'Bingo75'             : 24,
      'BingoMex'            : 16,
      'BingoAnimals'        : 16,
      'BingoCartoon'        : 16,
      'Movies'              : 16,
      'MoviesKids'          : 16,
      'XMas'                : 16,
      'Football'            : 16,
      'Halloween'           : 16,
      'Superheroes'         : 16,
      'Cartoon'             : 16
    };

    let board: Board;
    let boardEvents: EventsChannel;
    let playerEvents: EventsChannel;
    let hasFigure = false;
    let hasBingo = false;
    let containerWidth = 200;

    $: getBoard(player, game);

    onDestroy(() => {
        boardEvents?.destroy();
        playerEvents?.destroy();
    });

    async function getBoard(player: Player, game: Game): Promise<void> {
        boardEvents?.destroy();
        playerEvents?.destroy();
        playerEvents = player.getEventsChannel();

        playerEvents.on('board_created', ({ data }: RealTimeEvent) => {
            board = boardsFactory.createBoardFromDto(data.board);
            setupBoard();
        });

        board = await boardsService.getBoardByGameAndPlayer(game.roomId, game.id, player.id);
        
        if (board) {
            setupBoard();
        }
    }

    function setupBoard(): void {
        boardEvents?.destroy();
        hasFigure = board.hasFigure.value;
        hasBingo = board.hasBingo.value;
        boardEvents = board.getEventsChannel();
        boardEvents.on('figure', () => hasFigure = true);
        boardEvents.on('bingo', () => hasBingo = true);
        boardEvents.on('number_checked', ({ data }: RealTimeEvent) => board.checkCell(data.number));
    }

</script>

<div class="player" bind:clientWidth={containerWidth} class:has-figure={hasFigure} class:has-bingo={hasBingo} transition:fly={{ x: 100 }}>
    <div class="picture" style="width: {containerWidth * 0.25}px;">
        <AspectRatio>
            <Picture id={player.pictureId} />
        </AspectRatio>
    </div>
    <div class="info">
        <div class="name" style="font-size: {containerWidth * 0.005}rem; padding-top: {containerWidth * 0.007}px;">
            <Watch state={player.name} />
        </div>
        {#if board}
            <div class="checked-count" style="font-size: {containerWidth * 0.005}rem;">
                <Watch state={board?.checkedCount} />/{boardCellsByGameType[game.type]}
            </div>
        {/if}
    </div>
</div>

<style lang="scss">

    .player {
        width: 100%;
        display: flex;
        align-items: center;

        &.has-figure {

            .picture {
                border-color: var(--color-secondary);
            }

            .info {
                // border: 5px solid var(--color-secondary);
                background-color: var(--color-secondary);
                color: #000;
            }

        }
    }

    .picture {
        position: relative;
        z-index: 2;
        width: 6rem;
        border-radius: 50%;
        overflow: hidden;
        border: 5px solid #fff;

        :global(img) {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .info {
        flex: 1 1 0;
        box-sizing: border-box;
        margin-left: -3rem;
        padding-left: 4rem;
        padding-right: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: rgba(255, 255, 255, 0.5);
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
    }

    .name {
        font-family: ManagerTitle;
        font-size: 3rem;
        padding-top: 8px;
        box-sizing: border-box;
        max-width: 60%;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .checked-count {
        font-family: ManagerTitle;
        font-size: 2rem;
    }

</style>
